<template>
  <v-layout row wrap class="px-0">
    <v-flex xs12 v-for="sn in sitenotifications">
      <v-subheader>
        <b>#{{sn.sitenotificationid}}</b> &nbsp;&nbsp; {{dateFormat(sn.cts)}}
        <b v-if="sn.seen">&nbsp;&nbsp; просмотрено</b>
        <v-spacer></v-spacer>
        <v-btn text color="error" small @click="$emit('deleteSN', sn)">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-subheader>
      <v-card
        flat
        :style="sn.seen ? 'background-color: #F4F3F3' : 'background-color: #DBF0DB'"
        class="mb-4"
      >
        <v-card-text>
          <p v-html="sn.content"></p>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ListSitenotifications',
  props: [ 'sitenotifications' ],
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  }
}
</script>

<style lang="css">
</style>
